'use client';

import Button from '@/components/Button';
import { useStore } from '@/providers/app-store-provider';
import { useTranslations } from '@/i18n/use-translations';

const JoinAndEarnRewards = ({
  memberPrivileges,
  handleLogin,
  handleJoinNow,
  isWeb = false,
}: {
  memberPrivileges: any;
  handleLogin?: () => void;
  handleJoinNow: () => void;
  isWeb?: boolean;
}) => {
  const { join_desc } = memberPrivileges;
  const token = useStore((state) => state.token);
  const t = useTranslations('zeeloolRewards.joinAndEarn');

  if (!join_desc || !join_desc.info) {
    return null;
  }

  return (
    <div className={`text-center ${isWeb ? 'px-[44px] pt-[104px]' : 'px-52 py-[57px]'}`}>
      <div className="mx-auto max-w-[1200px]">
        <h2 className={`font-bb ${isWeb ? 'text-[32px]' : 'text-[24px] leading-[29px]'}`}>
          {join_desc.title}
        </h2>
        <div
          className={`mt-40 flex flex-col items-center justify-center gap-40 md:flex-row md:items-start ${isWeb ? 'mt-40' : 'mt-32'}`}
        >
          {join_desc.info.map((item: any) => (
            <div
              key={item.title}
              className={`flex flex-col items-center ${isWeb ? 'w-[320px]' : 'w-full'}`}
            >
              <h3 className={`font-bb ${isWeb ? 'mb-4 text-xl' : 'mb-[8px] text-16 leading-20'}`}>
                {item.title}
              </h3>
              <p
                className={`font-br text-[#808080] ${isWeb ? 'text-base' : 'text-[13px] leading-16'}`}
              >
                {item.description}
              </p>
            </div>
          ))}
        </div>
        <div className={` flex flex-col items-center ${isWeb ? 'mt-[30px]' : 'mt-[40px]'}`}>
          <Button
            variant="contained"
            color="black"
            radiusSize="large"
            className={`w-[240px] h-[40px] rounded-20 !bg-[#282828] text-white !text-14 ${isWeb ? '' : 'h-[36px] rounded-12'}`}
            onClick={() => handleJoinNow()}
          >
            {t('joinNowText')}
          </Button>

          {!token && (
            <a
              href="#"
              className={`text-[#808080] flex items-center ${isWeb ? 'mt-16 text-sm' : 'mt-10 text-12 leading-14'}`}
            >
              {t('loginText')}&nbsp;
              <span className="text-[#808080] underline" onClick={() => handleLogin()}>
                {t('loginHref')}
              </span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default JoinAndEarnRewards;
